// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredient__BreadBottom__2z9NQ","BreadTop":"BurgerIngredient__BreadTop__2Pkwe","Seeds1":"BurgerIngredient__Seeds1__2k2x7","Seds1":"BurgerIngredient__Seds1__AveGf","Seeds2":"BurgerIngredient__Seeds2__9Mret","Meat":"BurgerIngredient__Meat__1LdrR","Cheese":"BurgerIngredient__Cheese__1eqwP","Salad":"BurgerIngredient__Salad__2WBlr","Bacon":"BurgerIngredient__Bacon__2RZZH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredient/BurgerIngredient.css
// module id = 49
// module chunks = 0